import { useMemo } from 'react';

import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';

import { GridColDef } from '@mui/x-data-grid-pro';

const useColumnDefinitions = () => {
  const { t } = useTranslation();

  return useMemo(() => {
    return generateColumns(t);
  }, [t]);
};

const generateColumns = (t: TFunction): GridColDef[] => [
  {
    field: 'fromCountryCode',
    headerName: t('distances.grid.fromCountryCode'),
    type: 'string',
    hideable: false,
    minWidth: 130,
    flex: 1
  },
  {
    field: 'fromPostalcode',
    headerName: t('distances.grid.fromPostalcode'),
    type: 'string',
    minWidth: 130,
    flex: 1
  },
  {
    field: 'toCountryCode',
    headerName: t('distances.grid.toCountryCode'),
    type: 'string',
    minWidth: 130,
    flex: 1
  },
  {
    field: 'toPostalcode',
    headerName: t('distances.grid.toPostalcode'),
    type: 'string',
    minWidth: 130,
    flex: 1
  },
  {
    field: 'distanceShortest',
    headerName: t('distances.grid.distanceShortest'),
    type: 'number',
    minWidth: 150,
    flex: 1,
    align: 'left',
    headerAlign: 'left'
  },
  {
    field: 'traveltimeShortest',
    headerName: t('distances.grid.traveltimeShortest'),
    type: 'number',
    minWidth: 150,
    flex: 1,
    align: 'left',
    headerAlign: 'left'
  },
  {
    field: 'distanceFastest',
    headerName: t('distances.grid.distanceFastest'),
    type: 'number',
    minWidth: 150,
    flex: 1,
    align: 'left',
    headerAlign: 'left'
  },
  {
    field: 'traveltimeFastest',
    headerName: t('distances.grid.traveltimeFastest'),
    type: 'number',
    minWidth: 150,
    flex: 1,
    align: 'left',
    headerAlign: 'left'
  }
];

export default useColumnDefinitions;
